import { render, staticRenderFns } from "./BackendJavaDeploy.vue?vue&type=template&id=51cd376d&scoped=true&"
import script from "./BackendJavaDeploy.vue?vue&type=script&lang=js&"
export * from "./BackendJavaDeploy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cd376d",
  null
  
)

export default component.exports